export class StatisticsModel {
  arrival_list_guest_count: number;
  online_check_in_guest_count: number;
  waiting_room_no_guest_count: number;
  asking_question_guest_count: number;
  waiting_for_reply_guest_count: number;
  guests: number;
  requests: MenuItems[];

  constructor(arrival_list_guest_count = 0,
              online_check_in_guest_count = 0,
              waiting_room_no_guest_count = 0,
              asking_question_guest_count = 0,
              waiting_for_reply_guest_count = 0,
              guests = 0) {
    this.arrival_list_guest_count = arrival_list_guest_count;
    this.online_check_in_guest_count = online_check_in_guest_count;
    this.waiting_room_no_guest_count = waiting_room_no_guest_count;
    this.asking_question_guest_count = asking_question_guest_count;
    this.waiting_for_reply_guest_count = waiting_for_reply_guest_count;
    this.guests = guests;
  }
}

export class MenuItems {
  type: string;
  new_count: number;
  viewed_count: number;
  progress_count: number;
  managed_count: number;
  rejected: number;
}
